// extracted by mini-css-extract-plugin
export default {"address":"itemGrading_address__yfH71","button":"itemGrading_button__eltFM","add_btn":"itemGrading_add_btn__+4EdV","label":"itemGrading_label__0Z8kj"};